module.exports = __webpack_public_path__ + "img/index-service1-3A.a170a0ab.jpg";